import React from 'react';

const MDRIcon = ({ width = '14', height = '14', fill = '#000', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.125 3.57854V1.76109H4.9C4.66794 1.76109 4.44538 1.66832 4.28128 1.50319C4.11719 1.33805 4.025 1.11408 4.025 0.880547C4.025 0.647012 4.11719 0.423041 4.28128 0.257906C4.44538 0.0927717 4.66794 0 4.9 0L9.1 0C9.33206 0 9.55462 0.0927717 9.71872 0.257906C9.88281 0.423041 9.975 0.647012 9.975 0.880547C9.975 1.11408 9.88281 1.33805 9.71872 1.50319C9.55462 1.66832 9.33206 1.76109 9.1 1.76109H7.875V3.57854C9.43348 3.77611 10.8806 4.49544 11.9837 5.62084C13.0868 6.74625 13.7817 8.21231 13.9566 9.78323C13.9676 9.88179 13.9579 9.98159 13.9279 10.0761C13.898 10.1706 13.8486 10.2577 13.7829 10.3316C13.7172 10.4055 13.6368 10.4647 13.5468 10.5052C13.4568 10.5457 13.3594 10.5666 13.2608 10.5666H0.7392C0.640642 10.5666 0.543189 10.5457 0.453219 10.5052C0.363249 10.4647 0.282789 10.4055 0.217106 10.3316C0.151423 10.2577 0.101997 10.1706 0.072063 10.0761C0.0421289 9.98159 0.0323615 9.88179 0.0434 9.78323C0.218323 8.21231 0.913205 6.74625 2.01628 5.62084C3.11936 4.49544 4.56652 3.77611 6.125 3.57854ZM1.05 11.8867H12.95C13.2285 11.8867 13.4955 11.998 13.6925 12.1962C13.8894 12.3943 14 12.6631 14 12.9433C14 13.2236 13.8894 13.4923 13.6925 13.6905C13.4955 13.8887 13.2285 14 12.95 14H1.05C0.771523 14 0.504451 13.8887 0.307538 13.6905C0.110625 13.4923 0 13.2236 0 12.9433C0 12.6631 0.110625 12.3943 0.307538 12.1962C0.504451 11.998 0.771523 11.8867 1.05 11.8867Z"
      fill={fill}
    />
  </svg>
);

export default MDRIcon;
